export interface IDosageRecommendationRequestModel {
	gallons: number | null;
	measurement: 'usa' | 'metric';
	waterTemperatureCurrentF: number | null;
	phCurrent: number | null;
	totalAlkalinityCurrent: number | null;
	calciumCurrent: number | null;
	cyaCurrent: number | null;
	saltCurrent: number | null;
	boratesCurrent: number | null;
	chlorineCurrent: number | null;
	phosphateCurrent: number | null;
	phDesired: number | null;
	totalAlkalinityDesired: number | null;
	calciumDesired: number | null;
	cyaDesired: number | null;
	saltDesired: number | null;
	boratesDesired: number | null;
	chlorineDesired: number | null;
	phosphateDesired: number | null;
	waterTemperatureDesiredF: number | null;
}

export class DosageRecommendationRequestModel implements IDosageRecommendationRequestModel {
	gallons: number | null = null;
	measurement: 'usa' | 'metric' = 'usa';
	waterTemperatureCurrentF: number | null = null;
	phCurrent: number | null = null;
	totalAlkalinityCurrent: number | null = null;
	calciumCurrent: number | null = null;
	cyaCurrent: number | null = null;
	saltCurrent: number | null = null;
	boratesCurrent: number | null = null;
	chlorineCurrent: number | null = null;
	phosphateCurrent: number | null = null;
	phDesired: number | null = null;
	totalAlkalinityDesired: number | null = null;
	calciumDesired: number | null = null;
	cyaDesired: number | null = null;
	saltDesired: number | null = null;
	boratesDesired: number | null = null;
	chlorineDesired: number | null = null;
	phosphateDesired: number | null = null;
	waterTemperatureDesiredF: number | null = null;

	constructor(init?: Partial<IDosageRecommendationRequestModel>) {
		Object.assign(this, init);
	}
}

export interface DosageRecommendationResponse {
	actions: {
		[key: string]: DosageAction[];
	};
	maintenance: {
		[productName: string]: MaintenanceEntry;
	};
}

export interface DosageAction {
	name: string;
	value?: MeasurementValue;
}

export interface MeasurementValue {
	quantity: number;
	measurement: string;
}

export interface MaintenanceEntry {
	purge?: MeasurementValue;
	residentialWeekly?: MeasurementValue;
	commercialWeekly?: MeasurementValue;
	weekly?: MeasurementValue;
	useAsNeeded?: MeasurementValue;
}

